<script>
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import FramedImage from '../components/FramedImage.svelte'
  import AnimatedBullets from '../components/AnimatedBullets.svelte'
  import Diagram from '../charts/HHAddressible.svelte'
  import AnimatedLine from '../components/AnimatedLine.svelte'
  import AnimatedBlock from '../components/AnimatedBlock.svelte'
</script>
<section class="part5">
  <div class="rgrid-md-3-4">
    <div class="col">
      <AnimatedTitle class="large">One interface. <span class="nowrap">Multiple benefits.</span></AnimatedTitle>
      <AnimatedBlock><p class="subtitle">Verizon Media DSP is the first in the market to offer a single platform for both CTV and Household Addressable inventory in a robust self-serve environment.</p></AnimatedBlock>
      <AnimatedTitle class="medium title2">Household Addressable is linear TV inventory targetable at the household level.</AnimatedTitle>
    </div>
  </div>
  <div class="rgrid-md-12-col">
    <div class="tv-wrap">
      <FramedImage
        title=""
        showLogo={false}
        mobile="https://res.cloudinary.com/tanka-design/image/upload/c_scale,h_370,q_auto/v1616163348/VerizonMediaATV/tv-image4-desktop_uvk1aw.jpg"
        desktop="https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1616163348/VerizonMediaATV/tv-image4-desktop_uvk1aw.jpg"
        alt="Family using various devices at home" />
    </div>
  </div>
    
  <div class="rgrid-md-3-4">
    <div class="col">
      <AnimatedBullets>
        <li>Think of Addressable TV as the CTV of the linear TV world.</li>
        <li>Like CTV, Addressable TV allows advertisers to buy and measure ROI for a precise audience, rather than the program.</li>
        <li>With Addressable TV, you and your next-door neighbor can be watching the same show, but you both end up viewing different ads.</li>
      </AnimatedBullets>
    </div>
  </div>
  <div class="diagram">
    <Diagram />
    <div class="stats">
      <div class="stat">
        <AnimatedLine color="red" size={3} desktopSize={5} style="left" />
        <AnimatedBlock>
          <p>Household Addressable shares many targeting and measurement capabilities with CTV, making them a logical pairing.</p>
        </AnimatedBlock>
      </div>
      <div class="stat">
        <AnimatedLine color="red" size={3} desktopSize={5} style="left" delay={0.2} />
        <AnimatedBlock delay={0.2}>
          <p>Precisely reach your audience on the largest screen in the home, whether they’re watching on linear or digital platforms.</p>
        </AnimatedBlock>
      </div>
    </div>
  </div>
</section>

<style>
  .part5 :global(.subtitle) {
    margin-bottom: 3.875rem;
  }
  .part5 :global(.title2) {
    margin-top: 4.5rem;
  }
  .diagram {
    margin-top: 4.25rem;
    margin-bottom: 2rem;
  }
  .stats {
    margin-top: 3rem;
    display: grid;
    gap: calc(var(--gutter-sm) * 2);
    grid-template-columns: repeat(2,1fr);
  }
  .stat {
    font-weight: 500;
  }
  .stat :global(p) {
    margin: 0.5625rem 0 0;
  }
  .tv-wrap {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  @media(min-width: 768px) {
    .tv-wrap {
      grid-column: 3 / span 8;
      margin-top: 2rem;
      margin-bottom: 3rem;
    }
    .diagram {
      margin-top: 6rem;
      margin-bottom: 4rem;
    }
  }
</style>